import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useGetCurrentQuery } from "store/queries/account";
import { userSelector } from "store/slices/user";

export function useCurrentAccount() {
  const { currentAccount } = useSelector(userSelector);
  const location = useLocation();

  const shouldSkip = useMemo(() => {
    const pathParts = location.pathname.split("/");
    return pathParts[1] === "order";
  }, [location]);

  const { data, isLoading, isFetching, refetch } = useGetCurrentQuery(null, {
    skip: shouldSkip,
  });

  useEffect(() => {
    if (!shouldSkip) {
      refetch();
    }
  }, [currentAccount, shouldSkip]);

  const accountInfo = useMemo(() => {
    if (!data || !data.data) {
      return undefined;
    }

    return data.data;
  }, [data]);

  return { accountInfo, loaded: !isLoading || !isFetching };
}
